import React, {Component} from 'react';

import {ControlCentralContent} from "./control_central/ControlCentralContent";
import {withRouterParams} from "../../utils/withRouterParams";

class ClientControlCentralComponent extends Component {
    render() {
        return (
            <ControlCentralContent
                key={this.props.match.params.id}
                clientId={this.props.match.params.id}
                history={this.props.history}
            />
        );
    }
}

export default withRouterParams(ClientControlCentralComponent);
